import salesReportRoutes from '@/domain/salesReport/routes'

const TheContainer = () => import('@/containers/TheContainer')
const Stats = () => import('@/views_pica/stats/Stats')

export default [
    {
        path: '/reports',
        redirect: '/reports/sales-report',
        component: TheContainer,
        children: [
            ...salesReportRoutes,
            {
                path: 'stats',
                name: 'statsEvents',
                component: Stats,
                props: {isMultiEvents: true},
                meta: {
                    title: 'Events analytics',
                    label: 'Events analytics',
                    perms: ['menu.stats_multy_event']
                },
            },
        ]
    },


]

